angular.module( 'acme.view.application.account.departments', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.account.departments.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var accountDepartments = {
        name: 'application.account.departments',
        url: '/departments',
        views: {
          "subview-main": {
            controller: 'AccountDepartmentsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/account/departments/departments.tpl.html'
          }
        },
        data: {
          pageTitle: 'Manage Departments',
          permissions: ['DEPT_VIEW']
        }
      };

    $stateProvider
      .state(accountDepartments);
});
